<template>
  <el-dialog
    title="储值卡售卡"
    :visible.sync="show"
    width="60%"
    v-loading="loading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0)"
    :before-close="() => handleCloseFun(false)">
    <div class="content">
      <div class="filter" v-if="!type">
        <span>扫描售卡：</span>
        <el-input v-model.trim="cardNo" placeholder="" size="small" @keyup.native.enter="tapFun"></el-input>
      </div>
      <div class="action_box" v-if="type !== 1">
        <template v-if="!type">
          <el-button size="small" @click="handleCloseFun(true)">取消</el-button>
          <el-button type="primary" size="small" @click="sendOrAwaitCardFun(false)">待发卡</el-button>
        </template>
        <el-button type="primary" size="small" @click="sendOrAwaitCardFun(true)">发卡</el-button>
      </div>
      <el-divider v-if="type !== 1"></el-divider>
      <div class="form">
        <el-form v-if="type != 1" ref="form" :model="form" :inline="true" :disabled="!!type" label-width="100px">
          <el-form-item label="合同编号：">
            <el-input v-model="form.contactSn" placeholder="请输入合同编号" size="mini" maxlength="30" @change="saveCardHistory"></el-input>
          </el-form-item>
          <el-form-item label="购买人姓名：">
            <el-input v-model="form.customerName" placeholder="请输入购买人姓名" size="mini" maxlength="30" @change="saveCardHistory"></el-input>
          </el-form-item>
          <el-form-item label="身份证号：">
            <el-input v-model="form.customerSn" placeholder="请输入身份证号" size="mini" maxlength="30" @change="saveCardHistory"></el-input>
          </el-form-item>
          <el-form-item label="售卡调整价：">
            <el-input type="number" v-model="form.adjustAmount" placeholder="请输入售卡调整价" maxlength="30" size="mini" @change="saveCardHistory"></el-input>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model="form.remark" placeholder="请输入备注" size="mini" maxlength="30" @change="saveCardHistory"></el-input>
          </el-form-item>
        </el-form>
        <div v-if="type == 1" style="display: flex;flex-wrap: wrap">
          <div style="width:34%;display: flex;margin-bottom: 22px;">
            <span style="width:100px;text-align: right;margin-right: 20px;">合同编号：</span>
            <span style="flex:1">{{form.contactSn}}</span>
          </div>
          <div style="width:34%;display: flex;margin-bottom: 22px;">
            <span style="width:100px;text-align: right;margin-right: 20px;">购买人姓名：</span>
            <span style="flex:1">{{form.customerName}}</span>
          </div>
          <div style="width:34%;display: flex;margin-bottom: 22px;">
            <span style="width:100px;text-align: right;margin-right: 20px;">身份证号：</span>
            <span style="flex:1">{{form.customerSn}}</span>
          </div>
          <div style="width:34%;display: flex;margin-bottom: 22px;">
            <span style="width:100px;text-align: right;margin-right: 20px;">售卡调整价：</span>
            <span style="flex:1">{{form.adjustAmount}}</span>
          </div>
          <div style="width:34%;display: flex;margin-bottom: 22px;">
            <span style="width:100px;text-align: right;margin-right: 20px;">备注：</span>
            <span style="flex:1">{{form.remark}}</span>
          </div>
        </div>
        <div class="total_box">
          <div :style="{display: 'flex', alignItems: 'center', visibility: Table.data.length>0 && type!=1 ? 'visible'  : 'hidden'}">
            <el-checkbox :disabled="!!type" v-model="defaultFaceChecked">使用默认面值（元）：</el-checkbox>
            <el-input size="mini" type="number" v-model="defaultFaceInput" :disabled="!defaultFaceChecked"></el-input>
            <el-button type="primary" size="mini" :disabled="!defaultFaceChecked" @click="batchUpdateCardAmount">确认</el-button>
          </div>
          <div>
            <span>卡数量：<span>{{ form.cardNum || 0 }}</span> 张</span>
            <span>合计金额：<span>{{ form.cardTotalAmount || 0 }}</span> 元</span>
          </div>
        </div>
      </div>
      <el-divider></el-divider>
      <Table :TableParam="Table" style="margin: 0; padding: 0">
        <template v-slot:cardNature="{ item }">
          <span>{{ $label.getLabel($label.CardTypes, item.cardNature) }}</span>
        </template>
        <template v-slot:denomination="{ item }">
          <el-input v-model="item.denomination" type="number" :disabled="!!type" @change="changeFun($event, item.id)"></el-input>
        </template>
        <template v-slot:handle="{ item }">
          <el-button type="text" @click="deleteFun(item.id)">删除</el-button>
        </template>
        <template v-slot:Paging>
          <Paging @change="getItemList" :pager="pager" />
        </template>
      </Table>
    </div>
  </el-dialog>
</template>

<script>
import Table from "@/components/Table";
import Paging from "@/components/Paging";

export default {
  name: "Modal",
  components: {
    Table,
    Paging,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    info: {
      default: null
    },
    type: { // 0: 售卡 1: 详情 2: 发卡
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      defaultFaceChecked: false,
      defaultFaceInput: '',
      cardNo: '',
      count: 0,
      pager: {
        orderSn: '',
        id: '',
        page: 1,
        rows: 10,
        count: 0
      },
      form: {
        cardNum: 0,
        cardTotalAmount: 0
      },
      Table: {
        isHeader: false,
        handle: true,
        data: [],
        column: [
          { prop: 'batchSn', label: '批次号' },
          { prop: 'cardNature', label: '卡种类', slot: true },
          { prop: 'cardName', label: '卡名称' },
          { prop: 'cardNo', label: '卡号' },
          { prop: 'cardTypeName', label: '卡类型' },
          { prop: 'denomination', label: '面值(元)', slot: true },
          { prop: 'validPeriod', label: '有效期' },
          { prop: 'stateText', label: '状态' },
          { prop: 'inboundTime', label: '入库日期' },
        ]
      }
    };
  },
  watch:{
  },
  created () {
    this.init()
  },
  methods: {
    batchUpdateCardAmount() {
      if (!this.defaultFaceInput) {
        this.$message.warning('请输入默认面值')
        return
      }
      let params = {
        orderId: this.pager.id,
        amount: this.defaultFaceInput,
      }
      this.loading = true
      this.$http.batchUpdateCardAmountApi(params).then(res => {
        this.loading = false
        if (res) {
          if (res.status === 200) {
            this.init()
          } else {
            this.$message.error(res.msg)
          }
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 扫描售卡
    tapFun () {
      const cardNo = this.cardNo
      if(!cardNo) return
      const data = { 
        cardNo,
        id: this.form.id
      }
      this.$http.scanSellCardApi(data).then(res => {
        if(res.status === 200) {
          this.cardNo = ''
          this.$message.success(res.msg)
          this.getItemList()
        }
      })
    },
    // 发卡/待发卡
    async sendOrAwaitCardFun (flag) {
      const err = await this.setModal(null, () => (this.sendConfirm(flag)))
      if(err) return this.setModal({ title: err })
      if(typeof err === 'boolean') return
      this.$message.success('操作成功')
      this.$emit('getList')
      this.closeModal()
    },
    sendConfirm (flag) {
      const API = flag ? 'sendSaleCardApi' : 'awaitSendCardApi'
      return this.$http[API]({ orderId: this.form.id }).then(res => {
        if(res.status !== 200) return res.msg
      }).catch(err => {
        return err.message || err.error
      })
    },
    // 删除
    async deleteFun (id) {
      await this.$http.deleteSaleCardApi({ cardId: id })
      await this.saveCardHistory()
      await this.getItemList()
      const res = await this.getSellDraftList() 
      if(res) {
        this.form.cardTotalAmount = res?.cardTotalAmount || 0
      }
    },
    // 弹窗
  setModal (obj, cb) {
      const { tip = '提示', title = '确定当前操作?' } = obj || {}
      return this.$confirm(title, tip, {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async() => {
        if(!cb) return
        return await cb()
      }).catch(() => false)
    },

    // 查询售卡草稿
    getSellDraftList () {
      return this.$http.searchSellDraftApi().then(res => (res.data))
    },
    // 点击除(取消)时候关闭弹窗外保留当前的售卡草稿数据
    async handleCloseFun(flag = false) {
      if(flag) {
        const err = await this.setModal(null, () => (this.cancelCardOrder()))
        if(err) {
          this.setModal({ title: err })
        }
      }
      this.closeModal()
    },
    // 取消售卡订单
    cancelCardOrder () {
      return this.$http.cancelSellCardApi({ orderId: this.pager.id }).then(res => {
        if(res.status !== 200) return res
      })
    },
    closeModal () {
      this.$emit("update:show", false)
    },
    changeFun (e, id) {
      this.$http.updateCardAmountApi({ cardId: id, amount: Number(e) }).then(res => {
        const { cardNum , cardTotalAmount } = res.data || {}
        this.form.cardNum = cardNum || 0
        this.form.cardTotalAmount = cardTotalAmount || 0
      })
    },
    confirmFun() {},
    // 更新草稿的逻辑
    saveCardHistory () {
      if(this.type) return
      const { adjustAmount, contactSn, customerName, customerSn, id, remark } = this.form
      const data = { adjustAmount, contactSn, customerName, customerSn, id, remark }
      return this.$http.updateSellDraftApi(data)
    },
    // 获取关联的列表数据
    getItemList () {
      const{ orderSn, id, page, rows } = this.pager
      const data = {
        orderSn,
        id,
        pageNum: page,
        pageSize: rows
      }
      let api = (this.info && this.info.orderStatus == 3) ? 'searchOrderCardAllListApi' : 'searchOrderCardListApi'
      return this.$http[api](data).then(res => {
        this.Table.data = (res?.data?.list || []).map((item) => ({
          ...item,
          denomination: (item.denomination || ''),
          stateText: item.state.text,
        }))
        this.pager.count = res?.data?.total || 0
        this.form.cardNum = res?.data?.total || 0
      })
    },
    async init () {
      this.Table.handle = !this.type
      const res = !this.type ? await this.getSellDraftList() : this.info
      if(res) {
        const { id, orderSn } = res
        this.form = res
        this.pager.id = id
        this.pager.orderSn = orderSn
        this.getItemList()
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.filter {
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    margin: 0 10px;
    flex-shrink: 0;
  }
  .el-input {
    max-width: 600px;
  }
}
.action_box {
    margin: 20px 0;
    text-align: right;
}
.total_box {
  // text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    margin: 0 10px;
  }
}
.total_box > span > span {
  color: #f41111;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
</style>